import {
  MovementDocument,
  useMovementQuery,
  useUpdateMovementMutation,
} from '@shared/generated/graphql';
import { movementFromFragment } from '@shared/graphql/fromFragments/movement';
import { Movement } from '@shared/types/movement';
import { useCallback } from 'react';

type UseMovementOptions = {
  id: string;
  pollInterval?: number;
};

type UseMovementState = {
  movement?: Movement;
  isLoading: boolean;
  updateIsLoading: boolean;
  updateMovement: (input: UpdateMovementInput) => void;
};

type UpdateMovementInput = {
  id: string;
  pricing?: {
    targetPrice?: number;
    maxPrice?: number;
  };
  negotiationStrategyConfigOverride?: {
    strategyId?: string;
    strategyType?: string;
    config?: Record<string, unknown>;
  } | null;
};

const useMovement = (props: UseMovementOptions): UseMovementState => {
  const { id, pollInterval } = props;
  const { data, loading } = useMovementQuery({
    variables: { id },
    pollInterval,
  });
  const [update, { loading: updateIsLoading }] = useUpdateMovementMutation();

  const updateMovement = useCallback(
    (input: UpdateMovementInput) => {
      update({
        variables: { input },
        refetchQueries: [{ query: MovementDocument, variables: { id } }],
      });
    },
    [update, id]
  );

  const movement = data?.movementById
    ? movementFromFragment(data.movementById)
    : undefined;

  return { movement, isLoading: loading, updateIsLoading, updateMovement };
};

export default useMovement;
